/** شناسه کاربر لاگین‌شده از localStorage — هم‌منبع با AuthContext */
export const readCachedAuthUserId = () => {
  try {
    const raw = localStorage.getItem('userData');
    if (!raw) return null;
    const data = JSON.parse(raw);
    const id = data?.id;
    return id != null ? id : null;
  } catch {
    return null;
  }
};

/** دادهٔ کاربر لاگین‌شده از localStorage */
export const readCachedAuthUser = () => {
  try {
    const raw = localStorage.getItem('userData');
    if (!raw) return null;
    const data = JSON.parse(raw);
    return data && typeof data === 'object' ? data : null;
  } catch {
    return null;
  }
};

/** مالک پیش‌فرض فیلتر وقتی owner_id در URL نیست */
export const resolveDefaultOwnerFilterId = (searchParams, liveUserId = null) => {
  if (searchParams?.has?.('owner_id')) {
    return searchParams.get('owner_id') || 'all';
  }
  return liveUserId ?? readCachedAuthUserId() ?? 'all';
};
